var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15703 13.5867C2.19149 13.2766 2.20872 13.1215 2.25564 12.9766C2.29726 12.848 2.35607 12.7256 2.43048 12.6128C2.51434 12.4856 2.62466 12.3753 2.8453 12.1547L12.75 2.24998C13.5784 1.42156 14.9216 1.42156 15.75 2.24998C16.5784 3.07841 16.5784 4.42156 15.75 5.24998L5.84529 15.1547C5.62466 15.3753 5.51434 15.4856 5.38717 15.5695C5.27434 15.6439 5.15197 15.7027 5.02338 15.7443C4.87845 15.7913 4.72339 15.8085 4.41328 15.843L1.875 16.125L2.15703 13.5867Z",
    stroke: "#5E5873",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.cdf8e469b7365d4bfae4c7fbb4c1efeb.svg";
export { ForwardRef as ReactComponent };